export default "__VITE_ASSET__PEJWjszs__"